import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfirmationComponent',

  props: {
    modelValue: { type: Boolean, required: true },
    noCancel: { type: Boolean, default: false },
    persistent: { type: Boolean, default: false },
    confirmText: { type: String, default: '확인' },
    maxWidth: { type: Number, default: 390 },
    // 확인 버튼 비활성 — 버튼 disabled 뿐 아니라 confirm()·Enter 키도 막는다 (예: 해외배송 현지 발주 체크 전)
    confirmDisabled: { type: Boolean, default: false },
  },

  emits: ['confirm', 'cancel', 'update:modelValue'],

  data() {
    return {
      inputShow: true,
      pending: false, // 확인 처리 중 — Enter(전역 keydown)와 버튼 click 이 겹쳐도 confirm 은 한 번만
    }
  },

  computed: {
    open: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },

  watch: {
    // 다이얼로그가 "열릴 때"만 겹치는 스낵바를 숨기고 input 포커스 처리.
    // (이전엔 prop명 오타 modalValue + immediate 로, 컴포넌트가 마운트될 때마다
    //  무조건 hideSnackbar 가 호출되어 방금 띄운 에러 스낵바까지 닫아버리는 버그가 있었음)
    modelValue(value) {
      if (!value) return
      this.pending = false // 다시 열리면 새 확인을 받는다
      this.$store.commit('hideSnackbar')
      setTimeout(() => {
        this.$refs.confirmInput?.focus()
      }, 1)
      setTimeout(() => {
        this.inputShow = false
      }, 10)
    },
    open(value) {
      if (value && !this.persistent) {
        window.addEventListener('keydown', this.onKeydown)
      } else {
        window.removeEventListener('keydown', this.onKeydown)
      }
    },
  },

  beforeUnmount() {
    // 다이얼로그가 열린 채 컴포넌트가 unmount 될 때 keydown 리스너가 window 에 잔류하는 것을 방지
    window.removeEventListener('keydown', this.onKeydown)
  },

  methods: {
    cancel() {
      if (this.persistent) return

      // open setter 가 이미 update:modelValue 를 emit 하므로 직접 emit 은 중복(이중 emit) — 제거
      this.open = false
      // 취소 버튼 명시 클릭만 알린다 (ESC/바깥 클릭은 v-model 로만 닫힘) — 분기 처리가 필요한 호출자용
      this.$emit('cancel')
    },

    confirm() {
      if (this.confirmDisabled || this.pending) return
      this.pending = true // 동기 가드 — setTimeout 대기 중 두 번째 입력을 막는다

      setTimeout(() => {
        // 대기 중 비활성으로 바뀌었으면 처리하지 않는다
        if (this.confirmDisabled) {
          this.pending = false
          return
        }
        this.open = false
        this.$emit('confirm')
      }, 10)
    },

    onKeydown(e: KeyboardEvent) {
      if (e.key === 'Enter') {
        // 비활성일 때 Enter 로 체크를 우회하지 못하게 한다
        if (this.confirmDisabled) return
        this.confirm()
      }
    },
  },
})
